import { useDeerL1ModuleAndTeamType } from 'Deer/hooks/useDeerL1ModuleAndTeamType';
import { setMetricCardNavigateMetaData } from 'Deer/slice/MetricCardNavigateMetaData.slice';
import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { MODULE_WISE_METRIC_CARDS, MODULE_WISE_OVERVIEW_PAGE_METRIC_CARDS } from '../constants';
import { isOnTargetPage } from './useRouteMatchMetricCardFilter';

const getMetricCardsMeta = ({ module, l1Key, isOverviewPageCard }) => {
  if (isOverviewPageCard) {
    return MODULE_WISE_OVERVIEW_PAGE_METRIC_CARDS[module]?.[l1Key];
  }

  return MODULE_WISE_METRIC_CARDS[module];
};

const useMetricCardNavigateAndFilter = ({ cards, module, gridStatePersistenceKey, isOverviewPageCard = false }) => {
  const { l1Module, teamType } = useDeerL1ModuleAndTeamType();
  const l1Key = teamType || l1Module;
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  // if (checkSandboxStaticDataFeaturesEnabled() || checkNewStaticDataFeaturesEnabled()) {
  //   return cards;
  // }

  const metricCardsMetaForL1 = getMetricCardsMeta({ module, l1Key, isOverviewPageCard });
  if (!metricCardsMetaForL1 || isEmpty(metricCardsMetaForL1)) return cards;

  return cards.map((card) => {
    if (!metricCardsMetaForL1[card.cardId]) return card;

    const { targetPage, filters, filterKeysToClear, targetPageQueryParams = {} } = metricCardsMetaForL1[card.cardId];
    const onFilterClick = () => {
      // navigate to targetPage with filters if required
      const queryParams = new URLSearchParams();

      if (targetPage && !isOnTargetPage({ currentPath: location.pathname, targetPath: targetPage })) {
        Object.keys(targetPageQueryParams).forEach((key) => {
          queryParams.set(key, targetPageQueryParams[key]);
        });
        // navigate to target page
        history.push({
          pathname: targetPage,
          search: queryParams.toString(),
        });
      }
      // set filters to be applied
      if (filters) {
        dispatch(setMetricCardNavigateMetaData({ targetPage, filters, gridStatePersistenceKey }));
      }
    };

    const onFilterActiveClick = () => {
      // this will only happen when already on the target page, so we just need to clear the filter
      dispatch(setMetricCardNavigateMetaData({ gridStatePersistenceKey, filterKeysToClear }));
    };

    return {
      ...card,
      onFilterClick,
      onFilterActiveClick,
      targetPage,
      isOnTargetPage: targetPage && isOnTargetPage({ currentPath: location.pathname, targetPath: targetPage }),
      filters,
    };
  });
};

export { useMetricCardNavigateAndFilter };
